/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * 
 * @export
 * @interface TournamentPrizeTier
 */
export interface TournamentPrizeTier {
    /**
     * First finishing position this tier covers (1 = first place)
     * @type {number}
     * @memberof TournamentPrizeTier
     */
    rankStart: number;
    /**
     * Last finishing position this tier covers, inclusive
     * @type {number}
     * @memberof TournamentPrizeTier
     */
    rankEnd: number;
    /**
     * RewardConfigs granted to every entrant finishing inside the rank range
     * @type {Array<string>}
     * @memberof TournamentPrizeTier
     */
    rewardConfigIds: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof TournamentPrizeTier
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * Display label such as "Top 3"
     * @type {string}
     * @memberof TournamentPrizeTier
     */
    description?: string;
    /**
     * Display value such as "$500"
     * @type {string}
     * @memberof TournamentPrizeTier
     */
    displayValue?: string;
}

/**
 * Check if a given object implements the TournamentPrizeTier interface.
 */
export function instanceOfTournamentPrizeTier(value: object): value is TournamentPrizeTier {
    if (!('rankStart' in value) || value['rankStart'] === undefined) return false;
    if (!('rankEnd' in value) || value['rankEnd'] === undefined) return false;
    if (!('rewardConfigIds' in value) || value['rewardConfigIds'] === undefined) return false;
    return true;
}

export function TournamentPrizeTierFromJSON(json: any): TournamentPrizeTier {
    return TournamentPrizeTierFromJSONTyped(json, false);
}

export function TournamentPrizeTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizeTier {
    if (json == null) {
        return json;
    }
    return {
        
        'rankStart': json['rankStart'],
        'rankEnd': json['rankEnd'],
        'rewardConfigIds': json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'displayValue': json['displayValue'] == null ? undefined : json['displayValue'],
    };
}

export function TournamentPrizeTierToJSON(json: any): TournamentPrizeTier {
    return TournamentPrizeTierToJSONTyped(json, false);
}

export function TournamentPrizeTierToJSONTyped(value?: TournamentPrizeTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'description': value['description'],
        'displayValue': value['displayValue'],
    };
}

